import React from "react";
import { BrowserRouter } from "react-router-dom";

// Local components
import App from "./App";
import armTheme from "../styles/armTheme";

// Amplify components
import aws_exports from "../aws-exports";
import { Amplify } from "aws-amplify";
Amplify.configure(aws_exports);

// Material UI components
import { ThemeProvider, StyledEngineProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

const softShadow = "0 1px 2px rgba(15, 23, 42, 0.04), 0 1px 3px rgba(15, 23, 42, 0.06)";
const softShadowHover = "0 2px 4px rgba(15, 23, 42, 0.06), 0 4px 12px rgba(15, 23, 42, 0.08)";

const themeUI = createTheme({
  palette: {
    primary: {
      main: armTheme.colours.primary.main,
    },
    secondary: {
      main: armTheme.colours.secondary.main,
    },
    background: {
      default: "#fafaf7",
      paper: "#ffffff",
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          overscrollBehavior: "none",
        },
        body: {
          overscrollBehavior: "none",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: softShadow,
        },
        elevation0: {
          boxShadow: "none",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: softShadow,
          transition: "box-shadow 160ms ease, border-color 160ms ease",
          "&:hover": {
            boxShadow: softShadowHover,
          },
        },
      },
    },
  },
});

export default function Root() {
  return (
    <BrowserRouter>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={themeUI}>
          <CssBaseline />
          <App />
        </ThemeProvider>
      </StyledEngineProvider>
    </BrowserRouter>
  );
}
